/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const RewindCircleIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Rewind Circle',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M18 2A16 16 0 1 1 2 18 16 16 0 0 1 18 2Zm2 19.91 2.861 2.5a1 1 0 0 0 1.659-.753V12.249a1 1 0 0 0-1.659-.753L20 14Zm-3.658 2.5A1 1 0 0 0 18 23.662V12.248a1 1 0 0 0-1.658-.752l-7.383 6.459Z"
    />
  </svg>`;
};
